__turbopack_context__.v({
  "blob": "vvPfNq_blob",
  "blue": "vvPfNq_blue",
  "drift-blue": "vvPfNq_drift-blue",
  "drift-orange": "vvPfNq_drift-orange",
  "drift-pink": "vvPfNq_drift-pink",
  "drift-purple": "vvPfNq_drift-purple",
  "orange": "vvPfNq_orange",
  "pink": "vvPfNq_pink",
  "purple": "vvPfNq_purple",
});
